import React, { useEffect, useState, useMemo } from "react";

import SearchButton from "../../../components/buttons/search/search-btn";
import { newCompanyStatus } from "../companyRequest/userStatus";
import {
  user_company_list,
  send_bulk_emails,
} from "../admin.api";
import Notification from "../companyRequest/notification/notification";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import Pagination from "../../../components/table/Pagination";
import TextEditer from "../../../components/inputs/texteditor";
import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";

export default function BulkEmail(props) {
  const [data, setData] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [emailFormData, setEmailFormData] = useState({
    subject: '',
    body_html: '',
    metadata: {
      campaign: '',
      priority: 'normal'
    }
  });
  
  // Pagination settings (same as CustomTable)
  const PageSize = 10;
  
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleSelectAll = () => {
    console.log('handleSelectAll called, current selectAll:', selectAll);
    if (selectAll) {
      console.log('Deselecting all');
      setSelectedRows([]);
      setSelectAll(false);
    } else {
      const allIds = data.map(item => item.user_id);
      console.log('Selecting all IDs:', allIds);
      setSelectedRows(allIds);
      setSelectAll(true);
    }
  };

  const handleUnselectAll = () => {
    console.log('handleUnselectAll called');
    setSelectedRows([]);
    setSelectAll(false);
  };

  const handleRowSelect = (userId) => {
    console.log('handleRowSelect called with userId:', userId);
    console.log('Current selectedRows:', selectedRows);
    console.log('Data length:', data.length);
    
    if (selectedRows.includes(userId)) {
      const newSelectedRows = selectedRows.filter(id => id !== userId);
      console.log('Removing userId, new selectedRows:', newSelectedRows);
      setSelectedRows(newSelectedRows);
      setSelectAll(false);
    } else {
      const newSelectedRows = [...selectedRows, userId];
      console.log('Adding userId, new selectedRows:', newSelectedRows);
      setSelectedRows(newSelectedRows);
      if (newSelectedRows.length === data.length) {
        console.log('All items selected, setting selectAll to true');
        setSelectAll(true);
      }
    }
  };

  const getReuestList = (statusValue) => {
    setIsActive(true);
    const effectiveStatus = statusValue !== undefined ? statusValue : activeStatus;
    let param = {
      type: "kerala",
      status: effectiveStatus === "" ? "" : effectiveStatus,
    };
    user_company_list(param, adminType)
      .then((resp) => {
        console.log('Data loaded:', resp.data);
        setData(resp.data);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  const getStatusList = () => {
    setStatuses(newCompanyStatus);
  };

  const handleSearch = () => {
    // Reset to first page and fetch using current status
    setCurrentPage(1);
    getReuestList(activeStatus);
  };

  const manageStatus = (e) => {
    const value = e.target.value;
    setActiveStatus(value);
    // Immediately apply status filter and reset to first page
    setCurrentPage(1);
    getReuestList(value);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      getReuestList();
    }
  };

  const handleSendEmail = () => {
    const selectedCompanies = data.filter(item => selectedRows.includes(item.user_id));
    const emails = selectedCompanies.map(item => item.email).filter(email => email);
    
    if (emails.length === 0) {
      setSnackMessage("No valid email addresses found for selected companies");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    // Open email compose popup
    setShowEmailPopup(true);
  };

  const handleEmailSubmit = async () => {
    const selectedCompanies = data.filter(item => selectedRows.includes(item.user_id));
    const userIds = selectedCompanies.map(item => item.user_id).filter(user_id => user_id);
    const applicationIds = selectedCompanies.map(item => item.id).filter(id => id);
    
    // Create FormData for multipart/form-data with file uploads
    const formData = new FormData();
    
    // Append all the email data
    formData.append('user_category', 'companies');
    
    // Append user_ids as array
    userIds.forEach((id) => {
      formData.append('user_ids[]', id);
    });

    // Append application_id (singular key to match backend integer validation)
    applicationIds.forEach((id) => {
      formData.append('application_id', id);
    });
    
    formData.append('subject', emailFormData.subject);
    formData.append('body_html', emailFormData.body_html);
    
    // Append metadata as array fields
    formData.append('metadata[campaign]', emailFormData.metadata.campaign);
    formData.append('metadata[priority]', emailFormData.metadata.priority);
    
    // Append files as array
    selectedFiles.forEach((file) => {
      formData.append('documents[]', file);
    });

    console.log('Sending email with FormData:', formData);
    
    try {
      setIsActive(true);
      // Call the bulk email API with FormData
      const response = await send_bulk_emails(formData);
      
      setSnackMessage(response.message || `Email sent to ${selectedCompanies.length} companies successfully!`);
      setIsSnackError(false);
      setSnackOpen(true);
      setShowEmailPopup(false);
      
      // Uncheck all rows after successful email send
      setSelectedRows([]);
      setSelectAll(false);
      
      // Reset form and files
      setEmailFormData({
        subject: '',
        body_html: '',
        metadata: {
          campaign: '',
          priority: 'normal'
        }
      });
      setSelectedFiles([]);
    } catch (error) {
      console.error('Error sending bulk email:', error);
      setSnackMessage(error.message || 'Failed to send emails. Please try again.');
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  const handleEmailCancel = () => {
    setShowEmailPopup(false);
    // Reset form and files
    setEmailFormData({
      subject: '',
      body_html: '',
      metadata: {
        campaign: '',
        priority: 'normal'
      }
    });
    setSelectedFiles([]);
  };

  const handleEmailFormChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setEmailFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setEmailFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 5 * 1024 * 1024; // 5 MB

    const oversized = files.filter(f => f.size > maxSize);
    if (oversized.length > 0) {
      setSnackMessage(`File size must be less than 5 MB`);
      setIsSnackError(true);
      setSnackOpen(true);
      e.target.value = ''; // clear the file input
      return;
    }

    setSelectedFiles(files);
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    getReuestList();
  }, []);

  useEffect(() => {
    getStatusList();
  }, []);

  // Custom table component with pagination (same pattern as CustomTable)
  const CustomTableWithCheckbox = ({ data, columns }) => {
    // Pagination logic (same as CustomTable)
    const currentTableData = useMemo(() => {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return data?.slice(firstPageIndex, lastPageIndex);
    }, [data, currentPage]);

    return (
      <>
        <div className="table-responsive">
          <table className="table-bordered" style={{ width: '100%' }}>
            <thead className="thead-white thed">
              <tr>
                {columns.map((item, index) => (
                  <td
                    key={index}
                    className={
                      item.type === "status"
                        ? "statuscoloum"
                        : item.type === "notification"
                        ? "messagecoloum"
                        : item.type === "dynId"
                        ? "noFieldTableWidth"
                        : ""
                    }
                    style={{ color: "white", backgroundColor: "#666" }}
                  >
                    {item.title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody style={{ borderRight: "1px solid black" }}>
              {currentTableData && currentTableData.length > 0 ? (
                currentTableData.map((item, index) => (
                  <tr key={index}>
                    {columns.map((column, colIndex) => (
                      <td key={colIndex}>
                        {column.field === "select" ? (
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(item.user_id)}
                            onChange={(e) => {
                              e.stopPropagation();
                              console.log('Checkbox clicked for:', item.user_id, 'Checked:', e.target.checked);
                              handleRowSelect(item.user_id);
                            }}
                            style={{ cursor: 'pointer' }}
                          />
                        ) : column.type === "fullDate" ? (
                          item[column.field]
                            ? moment(item[column.field]).format("DD-MM-YYYY")
                            : ""
                        ) : column.type === "notification" ? (
                          <div
                            className="notificationContainer"
                            onClick={(e) => {
                              if (props.handleNotification) {
                                props.handleNotification(item);
                              }
                            }}
                          >
                            <span className={item[column.field] === 1 ? "activenoti" : "notificationItem"}>
                              🔔
                            </span>
                          </div>
                        ) : column.type === "regstatusType" ? (
                          <div className={getStatusClass(parseInt(item[column.field]))}>
                            {getStatusTitle(parseInt(item[column.field]))}
                          </div>
                        ) : (
                          item[column.field] || ""
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    style={{ textAlign: "center" }}
                    colSpan={columns.length}
                  >
                    No Records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination - Same as CustomTable */}
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={data.length}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </>
    );
  };

  const getStatusClass = (status) => {
    const statusClasses = {
      0: "pending",
      1: "inprogress", 
      2: "Accepted",
      3: "SA Reverted",
      4: "Rejected",
      5: "Reverted",
      6: "agrementexecution",
      7: "Ongoing Project"
    };
    return statusClasses[status] || "";
  };

  const getStatusTitle = (status) => {
    const statusTitles = {
      0: "Pending",
      1: "Submitted",
      2: "Accepted", 
      3: "SA Reverted",
      4: "Rejected",
      5: "Reverted",
      6: "Agreement Execution",
      7: "Ongoing Project"
    };
    return statusTitles[status] || "";
  };

  let tableColumns = [
    { title: "Select", field: "select" },
    { title: "Company Name", field: "company_name" },
    { title: "Application ID", field: "unique_application_ref_no" },
    { title: "Email", field: "email" },
    { title: "Phone Number", field: "phone_no" },
    {
      title: "Application Status",
      field: "project_status",
      type: "regstatusType",
    },
  ];

  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <Loader open={isActive} />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>Bulk Email - Kerala Companies</b>
          </h6>
          <div className="d-flex gap-2">
            <button
              className="px-2 py-2 btn btn-primary rounded"
              onClick={handleSelectAll}
            >
              Select All
            </button>
            {selectedRows.length > 0 && (
              <button
                className="px-2 py-2 btn btn-secondary rounded"
                onClick={handleUnselectAll}
              >
                Unselect All
              </button>
            )}
            {selectedRows.length > 0 && (
              <button
                className="px-2 py-2 search-style border-0 text-white rounded"
                onClick={handleSendEmail}
              >
                Send Email ({selectedRows.length})
              </button>
            )}
          </div>
        </div>
        <hr />

        <div className="row font-z">
          <div className="col-3">
            <select
              className="form-select"
              aria-label="Default select example"
              onChange={(e) => manageStatus(e)}
            >
              <option value={""}>Select Status</option>
              {statuses.map((item) => (
                <option
                  key={item.user_status_code}
                  value={item.user_status_code}
                >
                  {item.user_status_title}
                </option>
              ))}
              <option value={7}>Ongoing Projects</option>
              <option value={6}>Agreement Execution</option>
            </select>
          </div>
          <div className="col-1 d-flex">
            <SearchButton {...props} onClick={handleSearch} />
          </div>
        </div>
        
        <div className="mb-3">
          <small className="text-muted">
            {selectedRows.length} of {data.length} companies selected
          </small>
        </div>

        <CustomTableWithCheckbox 
          data={data} 
          columns={tableColumns}
          handleNotification={props.handleNotification}
        />
      </div>

      {/* Email Compose Popup */}
      {showEmailPopup && (
        <div className="modal-backdrop" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            paddingLeft: '20px',
            borderRadius: '8px',
            width: '100%',
            maxWidth: '900px',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div className="modal-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <h5 className="modal-title">Compose Email</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleEmailCancel}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '24px',
                  cursor: 'pointer',
                  marginBottom: '10px',
                  fontWeight: 'semibold',
                  opacity: 1,
                  filter: 'none'
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">To: {selectedRows.length} companies selected</label>
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Subject <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={emailFormData.subject}
                  onChange={(e) => handleEmailFormChange('subject', e.target.value)}
                  placeholder="Enter email subject"
                />
              </div>

              <div className="mb-3">
                <TextEditer
                  label={
                    <>
                      Message <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  value={emailFormData.body_html}
                  onChange={(value) => handleEmailFormChange('body_html', value)}
                  required={true}
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Campaign</label>
                  <input
                    type="text"
                    className="form-control"
                    value={emailFormData.metadata.campaign}
                    onChange={(e) => handleEmailFormChange('metadata.campaign', e.target.value)}
                    placeholder="Campaign name"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Priority</label>
                  <select
                    className="form-select"
                    value={emailFormData.metadata.priority}
                    onChange={(e) => handleEmailFormChange('metadata.priority', e.target.value)}
                  >
                    <option value="normal">Normal</option>
                    <option value="high">High</option>
                    <option value="low">Low</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Attachments</label>
                <input
                  type="file"
                  className="form-control"
                  multiple
                  onChange={handleFileChange}
                />
                {selectedFiles.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">Selected files:</small>
                    {selectedFiles.map((file, index) => (
                      <div key={index} className="d-flex justify-content-between align-items-center mt-1">
                        <small className="text-primary">{file.name} ({(file.size / 1024).toFixed(2)} KB)</small>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFile(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer" style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '20px'
            }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleEmailCancel}
                style={{ minWidth: 120, height: 40 }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleEmailSubmit}
                style={{ minWidth: 120, height: 40 }}
                disabled={!emailFormData.subject || !emailFormData.body_html}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
